import React, { Dispatch, ReactNode, SetStateAction } from 'react';
import Dialog from '@/components/molecules/Dialog/Dialog';
import ConsentForm from '@/components/organisms/Forms/ConsentForm';
import { useTranslation } from '@/src/i18n';
import { InstructionSection } from '@/components/utils/instruction';

type Props = {
  open: boolean;
  onSubmit: () => void;
  onClose: Dispatch<SetStateAction<boolean>>;
  instructionSections: InstructionSection[];
  topElement?: ReactNode;
};

const InstructionsDialog = ({
  open,
  onClose,
  onSubmit,
  instructionSections,
  topElement,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t('instructions-validation')}
      disableEscapeKeyDown
    >
      <ConsentForm
        onSubmit={onSubmit}
        instructionSections={instructionSections}
        topElement={topElement}
      />
    </Dialog>
  );
};
export default InstructionsDialog;
